import React, { useEffect, useState } from "react"
import { DeleteRecentVideosService, RecentVideosService } from "../../Services/Video";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination } from "@mui/material";
import { useTranslation } from "react-i18next";

const RecentVideos: React.FunctionComponent<{ change: boolean, onchangeMessageHandler: any }> = (props) => {

    const [listVideos, setListVideos] = useState<any>();
    const [dataLenght, setDataLenght] = useState<any>();
    const [totalPage, setTotalPage] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [videoValue, setVideoValue] = useState<any>("");
    const { t } = useTranslation();

    useEffect(() => {
        RecentVideosService(pageNumber).then((data) => {
            setTotalPage(data.pagination.pages);
            setListVideos(data.data);
            setDataLenght(data.data.length);
        }).catch(err => {
            console.log("error");
        });
    }, [pageNumber, isChange, props.change]);



    const handleChangePagination = (event: React.ChangeEvent<unknown>, value: number) => {
        setPageNumber(value);
    };

    const handleDownload = (url: any) => {
        try {
            const a = document.createElement('a');
            a.href = url;
            a.download = 'generated_video.mp4';
            a.click();
        } catch (error) {
            console.error('Error Download:', error);
        }
    };

    const handleDelete = () => {
        DeleteRecentVideosService(videoValue).then((data) => {
            setIsChange(!isChange);
            props.onchangeMessageHandler("success", "Video Deleted Successfully !")
        }).catch(err => {
            props.onchangeMessageHandler("error", "Error in deleting video !")

        });
    }

    return (
        <>
            <button className=" title-onest-18 bold-700  color-4F52C1 back-trans  border-trans padd-20" data-bs-toggle="modal" data-bs-target="#viewModal">{t("home.generatedVideos")}</button>

            <div className="modal fade" id="viewModal" aria-hidden="true">
                <div className="modal-dialog modal-xl  modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header  mb-4">
                            <h5 className="title-24">{t("home.generatedVideos")}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div className="modal-body">
                            <div className="card border-16">
                                <div className="row padd-24">
                                    {dataLenght == 0 ? <h3 className="empty text-center"> {t("listingVideo.noVideos")}</h3>
                                        :
                                        <>
                                            <div className="selected-videos mb-4" >
                                                <Swiper
                                                    key={pageNumber}
                                                    observer={true}
                                                    observeParents={true}
                                                    slidesPerView={1}
                                                    spaceBetween={30}
                                                    loop={false}
                                                    navigation={true}
                                                    modules={[Navigation]}
                                                    className="mySwiper"
                                                    breakpoints={{
                                                        320: {
                                                            slidesPerView: 1,
                                                            spaceBetween: 10,
                                                        },
                                                        576: {
                                                            slidesPerView: 2,
                                                            spaceBetween: 15,
                                                        },
                                                        768: {
                                                            slidesPerView: 3,
                                                            spaceBetween: 20,
                                                        },
                                                        992: {
                                                            slidesPerView: 4,
                                                            spaceBetween: 25,
                                                        },
                                                        1200: {
                                                            slidesPerView: 4,
                                                            spaceBetween: 30,
                                                        },
                                                    }}
                                                >
                                                    {listVideos?.map((video: any, index: number) => (
                                                        <SwiperSlide key={index}>
                                                            <div className="video-wrapper">
                                                                <label htmlFor={"video_" + index} className="videos mb-3">
                                                                    <video width="100%" height="auto" controls muted>
                                                                        <source src={video.src} type="video/mp4" />
                                                                    </video>
                                                                </label>
                                                                <div className="text-end mt-2">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => setVideoValue(video._id)}
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#dropModal"
                                                                        className="btn recent-download"
                                                                    >
                                                                        <i className="fa-solid fa-trash" style={{ color: "#716BE3" }}></i>
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleDownload(video.src)}
                                                                        className="btn recent-download"
                                                                    >
                                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M12.5003 18.9584H7.50033C2.97533 18.9584 1.04199 17.0251 1.04199 12.5001V7.50008C1.04199 2.97508 2.97533 1.04175 7.50033 1.04175H12.5003C17.0253 1.04175 18.9587 2.97508 18.9587 7.50008V12.5001C18.9587 17.0251 17.0253 18.9584 12.5003 18.9584ZM7.50033 2.29175C3.65866 2.29175 2.29199 3.65841 2.29199 7.50008V12.5001C2.29199 16.3417 3.65866 17.7084 7.50033 17.7084H12.5003C16.342 17.7084 17.7087 16.3417 17.7087 12.5001V7.50008C17.7087 3.65841 16.342 2.29175 12.5003 2.29175H7.50033Z" fill="#716BE3" />
                                                                            <path d="M9.99987 12.7167C9.84154 12.7167 9.6832 12.6583 9.5582 12.5333L7.0582 10.0333C6.81654 9.79166 6.81654 9.39167 7.0582 9.15C7.29987 8.90833 7.69987 8.90833 7.94153 9.15L9.99987 11.2083L12.0582 9.15C12.2999 8.90833 12.6999 8.90833 12.9415 9.15C13.1832 9.39167 13.1832 9.79166 12.9415 10.0333L10.4415 12.5333C10.3165 12.6583 10.1582 12.7167 9.99987 12.7167Z" fill="#716BE3" />
                                                                            <path d="M10 12.7167C9.65833 12.7167 9.375 12.4334 9.375 12.0917V5.42505C9.375 5.08338 9.65833 4.80005 10 4.80005C10.3417 4.80005 10.625 5.08338 10.625 5.42505V12.0917C10.625 12.4417 10.3417 12.7167 10 12.7167Z" fill="#716BE3" />
                                                                            <path d="M9.99971 15.1916C8.24138 15.1916 6.47471 14.9083 4.79971 14.35C4.47471 14.2416 4.29971 13.8833 4.40804 13.5583C4.51638 13.2333 4.86637 13.05 5.19971 13.1666C8.29971 14.2 11.708 14.2 14.808 13.1666C15.133 13.0583 15.4914 13.2333 15.5997 13.5583C15.708 13.8833 15.533 14.2416 15.208 14.35C13.5247 14.9166 11.758 15.1916 9.99971 15.1916Z" fill="#716BE3" />
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Pagination count={totalPage} variant="outlined" shape="rounded" onChange={handleChangePagination} />
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="dropModal" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel1">{t("propertiesPage.confirmation")}</h5>
                        </div>
                        <div className="modal-body">
                            <p>{t("listingVideo.msgConfirmationVideo")}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" style={{ float: "right" }} data-bs-dismiss="modal">
                                {t("propertiesPage.no")}
                            </button>
                            <button type="button" data-bs-dismiss="modal" style={{ float: "right" }} className="btn btn-danger" onClick={handleDelete}>
                                {t("propertiesPage.yes")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default RecentVideos;
